import { useSelector } from "react-redux";
import HashtagIcon from "assets/icons/Hashtag";
import "./fishPrint.css";
import { formatPrice } from "helpers";
import { useRef } from "react";
// @ts-ignore
import Num2persian from "num2persian";

export default function useOfficialFactor(props?: { factor?: Factor }) {
    const store = useSelector((state: any) => state);
    const factor: Factor = props?.factor || store.factorReducer?.factor;
    const business = store.businessReducer.business.business;
    const contentRef = useRef<any>(null);

    const settingExtractor = (key: string) => {
        let settings = factor.Person.Person_Settings
        return settings?.find(s => s.key === key)?.value ?? ''
    }

    let content = <></>;
    if (factor) {
        content = (
            <div
                className="bg-white items-center text-black p-5"
                ref={contentRef}
                style={{ direction: "rtl", lineHeight: '30px' }}
            >
                <div className="w-full row">
                    <div className="col-3">
                        <div className="text-[12px] text-right  text-nowrap">شماره سریال صورت حساب مالیاتی:</div>
                        <div className="text-[12px] text-right ">{factor.taxSerialMoaddian}</div>
                    </div>
                    <div className="col-6">
                        <div className="text-[20px] font-extrabold text-center pb-1">صورتحساب فروش کالا و خدمات</div>
                    </div>
                    <div className="text-left col-3">
                        <div className="text-[14px] text-left pb-1">شماره سریال: {factor.accountingCode}</div>
                        <div className="text-[14px] pb-1">تاریخ: {factor.date}</div>
                    </div>
                </div>

                <div className="w-full row border-2  border-[#000]">
                    <div className="border-[#000] text-center" style={{ borderBottom: '2px solid' }}>
                        <p>مشخصات فروشنده</p>
                    </div>
                    <div className="row" style={{ fontSize: '12px' }}>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">نام شخص حقیقی / حقوقی:</p>
                            <p className="mr-3">{business.legalName}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شماره اقتصادی:</p>
                            <p className="mr-3">{business.economicalCode}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شماره ثبت / شماره ملی:</p>
                            <p className="mr-3">{business.nationalID}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">استان:</p>
                            <p className="mr-3">{business.state}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شهر:</p>
                            <p className="mr-3">{business.city}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">کد پستی ۱۰ رقمی:</p>
                            <p className="mr-3">{business.postalCode}</p>
                        </div>
                        <div className="col-8 flex flex-row">
                            <p className="font-bold">نشانی:</p>
                            <p className="mr-3">{business.address}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شماره تلفن / نمابر:</p>
                            <p className="mr-3">{business.phone}</p>
                        </div>
                    </div>
                </div>

                <div className="w-full row border-2  border-[#000] mt-4">
                    <div className="border-[#000] text-center" style={{ borderBottom: '2px solid' }}>
                        <p>مشخصات خریدار</p>
                    </div>
                    <div className="row" style={{ fontSize: '12px' }}>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">نام شخص حقیقی / حقوقی</p>
                            <p className="mr-3">{factor.Person.company ?? ((factor.Person.firstName ?? "") + " " + (factor.Person.lastName ?? ""))}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شماره اقتصادی</p>
                            <p className="mr-3">{settingExtractor('nationalId')}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شماره ثبت / شماره ملی</p>
                            <p className="mr-3">{settingExtractor('nationalId')}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">استان</p>
                            <p className="mr-3">{settingExtractor('state')}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شهر</p>
                            <p className="mr-3">{settingExtractor('city')}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">کد پستی ۱۰ رقمی</p>
                            <p className="mr-3">{settingExtractor('postalCode')}</p>
                        </div>
                        <div className="col-8 flex flex-row">
                            <p className="font-bold">نشانی</p>
                            <p className="mr-3">{settingExtractor('address')}</p>
                        </div>
                        <div className="col-4 flex flex-row">
                            <p className="font-bold">شماره تلفن / نمابر</p>
                            <p className="mr-3">{settingExtractor('phone')}</p>
                        </div>
                    </div>
                </div>

                <div className="w-full row border-2 border-[#000] mt-4 border-bottom-0">
                    <p className="text-center font-bold" style={{ borderBottom: '2px solid #000' }}>مشخصات کالا و خدمات
                        مورد معامله</p>
                    <table
                        className="w-full table-bordered" style={{ borderWidth: '2px !important', lineHeight: '30px' }}>
                        <thead>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>
                                <HashtagIcon color="black" style={{ transform: "scale(1.0)" }} />
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}
                                className="w-[140px]">کد کالا
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>شرح کالا یا
                                خدمات
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>تعداد / مقدار
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>واحد اندازه
                                گیری
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>مبلغ واحد
                                (ریال)
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>مبلغ کل
                                (ریال)
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>مبلغ تخفیف
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>مبلغ کل پس از
                                تخفیف (ریال)
                            </th>
                            <th style={{
                                fontSize: "11px", borderLeft: "2px solid black",
                                borderBottom: "2px solid black",
                                padding: "3px",
                                textAlign: 'center'
                            }}>جمع عوارض و
                                مالیات (ریال)
                            </th>
                            <th style={{ fontSize: "11px", borderBottom: "2px solid black", padding: "3px", textAlign: 'center' }}>جمع مبلغ کل
                                بعلاوه جمع مالیات و عوارض (ریال)
                            </th>
                        </thead>
                        <tbody>
                            {factor.Factor_Items?.map((item, i) => {
                                return (
                                    <tr key={i}>
                                        <td className="text-center text-[11px] font-semibold" style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>{i + 1}</td>
                                        <td className="px-0 py-1"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span className="text-xs font-semibold">{item.Product?.accountingCode}</span>
                                        </td>
                                        <td style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>
                                            <span className="flex justify-center">{item.Product?.title}</span>
                                        </td>
                                        <td style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>
                                            <span>{item.quantity}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold" style={{
                                            borderLeft: "2px solid black",
                                            borderBottom: "2px solid black",
                                            padding: "3px",
                                            textAlign: 'center'
                                        }}>
                                            <span>{item.unit}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span>{formatPrice(item.price)}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span>{formatPrice(item.quantity * item.price)}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span>{formatPrice(item.discount ?? 0)}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span>{formatPrice((item.price * item.quantity) - (item.discount ?? 0))}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold"
                                            style={{
                                                borderLeft: "2px solid black",
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span>{formatPrice(item.tax ?? 0)}</span>
                                        </td>
                                        <td className="text-[11px] font-semibold"
                                            style={{
                                                borderBottom: "2px solid black",
                                                padding: "3px",
                                                textAlign: 'center'
                                            }}>
                                            <span>{formatPrice(item.totalOneProduct ?? 0)}</span>
                                        </td>
                                    </tr>
                                );
                            })}
                            <tr>
                                <td colSpan={6} className="text-[11px] font-semibold"
                                    style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>جمع کل
                                </td>
                                <td className="text-[11px] font-semibold"
                                    style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                    <span>{formatPrice(factor.Factor_Items?.reduce((acc, item) => acc + (item.quantity * item.price), 0))}</span>
                                </td>
                                <td className="text-[11px] font-semibold"
                                    style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                    <span>{formatPrice(factor.Factor_Items?.reduce((acc, item) => acc + (item.discount ?? 0), 0))}</span>
                                </td>
                                <td className="text-[11px] font-semibold"
                                    style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: 'center'
                                    }}>
                                    <span>{formatPrice(factor.Factor_Items?.reduce((acc, item) => acc + ((item.price * item.quantity) - (item.discount ?? 0)), 0))}</span>
                                </td>
                                <td className="text-[11px] font-semibold"
                                    style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black", padding: "3px", textAlign: 'center'
                                    }}>
                                    <span>{formatPrice(factor.Factor_Items?.reduce((acc, item) => acc + item.tax, 0))}</span>
                                </td>
                                <td className="text-[11px] font-semibold"
                                    style={{
                                        borderBottom: "2px solid black", padding: "3px", textAlign: 'center'
                                    }}>
                                    <span>{formatPrice(factor.Factor_Items?.reduce((acc, item) => acc + (item.totalOneProduct), 0))}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={6} className="text-[11px] font-semibold"
                                    style={{
                                        borderLeft: "2px solid black",
                                        borderBottom: "2px solid black",
                                        padding: "3px",
                                        textAlign: "center"
                                    }}>جمع کل به حروف
                                </td>
                                <td colSpan={6} className="text-[11px] font-semibold"
                                    style={{
                                        borderBottom: "2px solid black", padding: "3px", textAlign: "center"
                                    }}>
                                    <span>{Num2persian(factor?.totalPrice)} {factor?.Currency?.fa_title}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="clear-both"></div>

                <div className="w-full row d-block flex">
                    <div className="col-6">
                        <div className="row border-2  border-[#000] mt-4">
                            <div className="col-4">
                                <p>شرایط و نحوه فروش</p>
                            </div>
                            <div className="col-4">
                                <div>
                                    <span>نقدی</span>
                                    <input type="checkbox" className="mr-4" />
                                </div>
                            </div>
                            <div className="col-4">
                                <div>
                                    <span>غیر نقدی</span>
                                    <input type="checkbox" className="mr-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full row">
                    <div className="col-6">
                        <div className="row border-2  border-[#000] mt-4">
                            <div className="col-2">
                                <p>توضیحات:</p>
                            </div>
                            <div className="col-10">
                                <p>{factor.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="w-full row mt-4" style={{ height: '100px' }}>
                    <div className="col-6 border-2 border-[#000]" style={{ borderLeft: 0 }}>
                        <p>مهر و امضا فروشنده</p>
                    </div>
                    <div className="col-6 border-2  border-[#000]">
                        <p>مهر و امضا خریدار</p>
                    </div>
                </div>
            </div>
        );
    }
    return { content, contentRef };
}
